/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressDtoFromJSON, AddressDtoToJSON, } from './';
export function CollectorAdministratorCreateDtoFromJSON(json) {
    return CollectorAdministratorCreateDtoFromJSONTyped(json, false);
}
export function CollectorAdministratorCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'firstName': json['firstName'],
        'surname': json['surname'],
        'phoneNumber': json['phoneNumber'],
        'phoneNumberPrefix': json['phoneNumberPrefix'],
        'address': AddressDtoFromJSON(json['address']),
    };
}
export function CollectorAdministratorCreateDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'firstName': value.firstName,
        'surname': value.surname,
        'phoneNumber': value.phoneNumber,
        'phoneNumberPrefix': value.phoneNumberPrefix,
        'address': AddressDtoToJSON(value.address),
    };
}
